module.exports = __webpack_public_path__ + "media/images/main_post_bg-b8429828808049a4b85192d427d47305.png";